import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				position: "relative"
			},
			bodyPage: {
				transform: "translate(0, -50%)",
				width: "100%",
				top: "50%",
				position: "absolute"
			},
			text: {
				color: theme.palette.grey[900],
				fontSize: 15,
				padding: "5px 0px 40px"
			},
			btnBuy: {
				background: theme.palette.primary.main,
				color: theme.palette.text.contrastText,
				borderRadius: 4,
				cursor: "pointer",
				fontSize: 14,
				width: 136,
				textAlign: "center",
				padding: "8px 10px",
				"&&:active": {
					opacity: 0.7
				}
			}
		}),
	{
		name: "FindProduct",
		index: 1
	}
);

export default useStyles;
